import React from "react";
import PropTypes from "prop-types";

import { useTrans } from "../hooks";
import { Button, ButtonVariant } from "@wattpad/web-ui-library";
import PublishButton, {
  PublishButtonProps
} from "../views/writer/PublishButton";

const EditWorksButtons = ({
  draft,
  onPreview,
  onPreviewUnpublished,
  onSave,
  onCancel,
  publishButtonSettings
}) => {
  const { trans } = useTrans();

  return (
    <>
      <div className="button-container">
        {draft ? (
          <PublishButton {...publishButtonSettings} />
        ) : (
          <button className="btn publish-btn" onClick={onPreview}>
            {trans("Publish Changes")}
          </button>
        )}

        {draft ? (
          <>
            <Button onClick={onSave} variant={ButtonVariant.SECONDARY}>
              {trans("Save")}
            </Button>
            <Button
              onClick={onPreviewUnpublished}
              variant={ButtonVariant.SECONDARY}
            >
              {trans("Preview")}
            </Button>
          </>
        ) : (
          <Button onClick={onCancel} variant={ButtonVariant.SECONDARY}>
            {trans("Cancel")}
          </Button>
        )}
      </div>
    </>
  );
};

EditWorksButtons.propTypes = {
  draft: PropTypes.bool.isRequired,
  onSave: PropTypes.func,
  onPreview: PropTypes.func,
  onPreviewUnpublished: PropTypes.func,
  onCancel: PropTypes.func,
  publishButtonSettings: PropTypes.shape(PublishButtonProps)
};

export default EditWorksButtons;
